// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_appContainer__VtB61 {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.Layout_mainContent__NyGQv {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".appContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.mainContent {\n  flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appContainer": `Layout_appContainer__VtB61`,
	"mainContent": `Layout_mainContent__NyGQv`
};
export default ___CSS_LOADER_EXPORT___;
